//
//
//
//
//
//
//
//
export default {
  name: 'performance-label',
  props: {
    labelList: {
      type: Array,
      default: null
    }
  }
};